<h2 [class.small]="isSmall()" [class.large]="isLarge()">{{title}}</h2>